export default __webpack_public_path__ + "static/media/avatar_18.a4642166.svg";